import { styled } from 'styled-components';
import { StyledTableWrapper } from './AvailabilityTable/styled.ts';

const StyledTR = styled.tr`
  height: 30px;
  outline: inherit !important;
  padding-top: 5px;
`;

const StyledTD = styled.td<{ isAvailable?: boolean; isSold?: boolean }>`
  color: black !important;
  text-align: center !important;
  border: 2px solid grey !important;
  cursor: pointer !important;
  background-color: ${({ isAvailable, isSold }) =>
    isAvailable || isSold ? (isAvailable ? '#88F684' : 'red') : '#ffffff'} !important;
`;

const StyledRelativeContainer = styled.div`
  position: relative;
`;

const StyledTableContainer = styled(StyledTableWrapper)`
  margin-top: 40px;
`;

const InformationTable = () => (
  <div className="col-md-2">
    <StyledRelativeContainer>
      <StyledTableContainer>
        <table className="table custom-itinerary-table table-responsive">
          <tbody>
            <StyledTR>
              <StyledTD>
                <span>Available</span>
              </StyledTD>
              <StyledTD isAvailable />
            </StyledTR>
            <StyledTR>
              <StyledTD>
                <span>Sold</span>
              </StyledTD>
              <StyledTD isSold />
            </StyledTR>
          </tbody>
        </table>
      </StyledTableContainer>
    </StyledRelativeContainer>
  </div>
);

export default InformationTable;
